export default {
    name: 'layout-footer',
    components: {},
    props: [],
    data() {
        return {
            systemName: '健康及保險知識+',
            homepage: '首頁',
        };
    },
    computed: {},
    mounted() {},
    methods: {},
};
